export type VehicleProfileDocumentRow = {
    id: string;
    documentName: string;
    fileName: string;
    mime: string;
    dataBase64: string;
};

export function serializeVehicleProfileDocuments(raw: unknown): string | null {
    if (!Array.isArray(raw)) return null;
    const cleaned: VehicleProfileDocumentRow[] = [];
    for (const row of raw) {
        if (!row || typeof row !== 'object') continue;
        const r = row as Record<string, unknown>;
        const dataBase64 = String(r.dataBase64 ?? '').trim();
        if (!dataBase64) continue;
        const fileName = String(r.fileName ?? '').trim() || 'file';
        const docName =
            String(r.documentName ?? '').trim() ||
            fileName.replace(/\.[^/.]+$/, '') ||
            'Document';
        cleaned.push({
            id: String(r.id ?? '').trim() || `doc-${cleaned.length}`,
            documentName: docName,
            fileName,
            mime: String(r.mime ?? 'application/octet-stream').trim() || 'application/octet-stream',
            dataBase64,
        });
    }
    if (cleaned.length === 0) return null;
    return JSON.stringify(cleaned);
}

export function parseVehicleProfileDocumentsFromRecord(record: Record<string, unknown>): VehicleProfileDocumentRow[] {
    const docJson = record.vehicleProfileDocumentsJson ?? record.VehicleProfileDocumentsJson;
    if (typeof docJson === 'string' && docJson.trim()) {
        try {
            const arr = JSON.parse(docJson) as unknown[];
            if (Array.isArray(arr)) {
                return arr.map((x, idx) => {
                    const o = (x && typeof x === 'object' ? x : {}) as Record<string, unknown>;
                    const fileName = String(o.fileName ?? o.name ?? '').trim();
                    const dataBase64 = String(o.dataBase64 ?? '').trim();
                    const id = String(o.id ?? '').trim() || `doc-${idx}`;
                    const documentName =
                        String(o.documentName ?? '').trim() ||
                        (fileName ? fileName.replace(/\.[^/.]+$/, '') : `Document ${idx + 1}`);
                    return {
                        id,
                        documentName,
                        fileName: fileName || 'file',
                        mime: String(o.mime ?? 'application/octet-stream').trim() || 'application/octet-stream',
                        dataBase64,
                    };
                });
            }
        } catch {
            /* ignore */
        }
    }
    if (Array.isArray(record.vehicleProfileDocuments)) {
        return record.vehicleProfileDocuments as VehicleProfileDocumentRow[];
    }
    return [];
}
